import {
  SectionGroup,
  TestimonialShortStoryList,
} from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { marginH } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import { move } from 'ramda'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const moveAdamTestimonialToBeLast = move(0, -1)

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Main = styled.div`
  ${marginH(-1)}
`

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const TestimonialSection = ({ title, body, stories, id }) => (
  <SectionGroup title={title} isClose>
    <CopyParagraph>{body}</CopyParagraph>
    <Main>
      <TestimonialShortStoryList
        stories={moveAdamTestimonialToBeLast(stories)}
        id={id}
      />
    </Main>
  </SectionGroup>
)

TestimonialSection.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  stories: PropTypes.arrayOf(PropTypes.object).isRequired,
  id: PropTypes.string,
}

TestimonialSection.defaultProps = {
  id: `patient-short=stories-list`,
}

export default TestimonialSection
